import { fetch } from '../../../store/fetch';

export function getQuestionnaireCardTitle(label: string, isLifestyleQuestionnaire?: boolean) {
    if (isLifestyleQuestionnaire) {
        return 'Een paar extra vragen';
    }

    return label === 'ess' ? 'Hoe slaperig ben je overdag?' : 'Welke klachten ervaar je?';
}

async function openReferralLetterIfAvailable(url: string) {
    const newTab = window.open('', '_blank');

    const res = await fetch(url, 'GET');

    if (res.status === 200) {
        if (newTab) {
            newTab.location = url;
        } else {
            window.open(url, '_blank');
        }
    } else {
        newTab?.close();
    }
}

export async function onDownloadReferralLetter(requestId?: string, userHasOsasMraReferralLetter?: boolean) {
    if (requestId) {
        await openReferralLetterIfAvailable(`/api/patient/mraReferralLetter/${requestId}`);

        return;
    }

    if (userHasOsasMraReferralLetter) {
        await openReferralLetterIfAvailable('/api/patient/osasMraReferralLetter');
    }
}
